import { render } from "./GamificationQuests.vue?vue&type=template&id=e86abe38"
import script from "./GamificationQuests.vue?vue&type=script&lang=js"
export * from "./GamificationQuests.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__